const bootstrap = require('bootstrap');

window.showModal = function(modalId, getCurrentPosition = false, toggleToId = null)
{
    let modal = new bootstrap.Modal(document.getElementById(modalId));
    let modalEl = document.getElementById(modalId)

    if (getCurrentPosition) {
        modalEl.addEventListener('shown.bs.modal', function () {
            Livewire.dispatch('currentPositionStart');
            navigator.geolocation.getCurrentPosition(function (position) {
                let coordinates = position.coords;
                Livewire.dispatch('currentPositionUpdated', { lat: coordinates.latitude, lng: coordinates.longitude });
            }, function (error) {
                Livewire.dispatch('currentPositionError', { code: error.code, message: error.message });
            }, {
                enableHighAccuracy: false,
                timeout: 5000,
                maximumAge: 0
            });
        });
    }

    if (toggleToId) {
        modal.toggle(toggleToId);
    }

    modal.show();
}

window.hideModal = function(modalId)
{
    let modalEl = document.getElementById(modalId);
    let modal = bootstrap.Modal.getInstance(modalEl);

    if (!modal) {
        return;
    }

    modal.hide();
}

window.addEventListener('livewire:initialized', function() {
    Livewire.dispatch('livewireLoaded');

    Livewire.on('showModal', function(options) {
        window.showModal(options.modalId, options.getCurrentPosition);
    });

    Livewire.on('hideModal', function(options) {
        window.hideModal(options.modalId);
    });

    Livewire.on('dataLayer.push', function(options) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(options.json);
    });
});
